import Vue from 'vue'
import 'amfe-flexible'
import App from './App.vue'
import router from './router'
import store from './store'
import http from '@/utils/request.js'
import '@/utils/vant-ui.js'
import '@/styles/index.scss'
import { getRelativeTime } from '@/utils/date-time.js'

Vue.prototype.$http = http
Vue.prototype.$eventBus = new Vue()
Vue.filter('relative', getRelativeTime)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
